function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import user_security_service from '@/apps/data-platform/services/security/user_security_service';
import { localPaginationMixin } from '@/mixins/local_pagination';
import tasks from '@/js/tasks';
import { mapMutations } from 'vuex';
import XLSX from "xlsx";
export default {
  name: 'LogAccess',
  mixins: [localPaginationMixin],
  data: function data() {
    return {
      Items: [],
      filter_enabled: true,
      valid: true,
      dates: null,
      menu2: false,
      filter: {
        text_filter: '',
        domain: null
      },
      headers: [{
        text: 'Email',
        align: 'start',
        sortable: false,
        value: 'email'
      }, {
        text: 'Dominio',
        value: 'domain'
      }, {
        text: 'Fecha creación',
        value: 'creation_date'
      }, {
        text: 'Último acceso',
        value: 'last_date'
      }, {
        text: 'Acciones',
        value: 'actions'
      }
      //{ text: 'Estado', value: 'status' },
      ],
      fecha_id: 0,
      fechas: [{
        id: 1,
        name: 'Hoy'
      }, {
        id: 2,
        name: 'Último mes'
      }, {
        id: 6,
        name: 'Todo'
      }],
      search: '',
      isLoading: false,
      domains: []
    };
  },
  beforeMount: function beforeMount() {
    this.getAccessLog();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onLimpiar: function onLimpiar() {
      this.$refs.form.resetValidation();
      this.search = '';
    },
    onSearch: function onSearch() {
      if (!this.validate()) {
        return;
      }
      if (this.filter.text_filter.length > 0) {
        this.search = this.filter.text_filter;
      } else {
        this.search = this.filter.domain;
      }
    },
    onDownload: function onDownload() {
      var _this = this;
      var data = [];
      this.Items.forEach(function (x) {
        data.push(Object.assign({}, x));
      });
      data.forEach(function (x) {
        x.creation_date = x.creation_date ? _this.getDateAndHours2(x.creation_date) : '';
        x.last_date = x.last_date ? _this.getDateAndHours2(x.last_date) : '';
        x.verify_date = x.verify_date ? _this.getDateAndHours2(x.verify_date) : '';
      });
      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Datos");
      var excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array"
      });
      var blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "historico_accesos.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    getAccessLog: function getAccessLog() {
      var _this2 = this;
      try {
        this.isLoading = true;
        this.setShowLoading(true);
        var all_domains = [];
        var dominios_unicos = [];
        MonitoringAccessService.getAccessLog().then(function (response) {
          if (response && response.data) {
            console.log(response);
            _this2.Items = response.data;
            response.data.forEach(function (element) {
              all_domains.push(element.domain);
            });
            dominios_unicos = _toConsumableArray(new Set(all_domains));
            dominios_unicos = dominios_unicos.sort();
            _this2.domains.push({
              id: '',
              name: 'Todos'
            });
            dominios_unicos.forEach(function (item) {
              _this2.domains.push({
                id: item,
                name: item
              });
            });
            _this2.isLoading = false;
            _this2.setShowLoading(false);
          }
        });
      } catch (error) {
        this.isLoading = false;
        tasks.toast.error('Error');
      }
    },
    getDateAndHours: function getDateAndHours(created) {
      // console.log(created)
      var date = new Date(created);
      date.setHours(date.getHours() - 5);
      // console.log(date)
      // const timeDifference = date.getTimezoneOffset()
      // console.log(`Timezone offset: ${timeDifference}`)
      return {
        date: this.$moment(date).format('DD-MM-YYYY'),
        hour: this.$moment(date.setHours(date.getHours() + 5)).format('HH:mm:ss')
      };
    },
    getDateAndHours2: function getDateAndHours2(created) {
      // console.log(created)
      var date = new Date(created);
      date.setHours(date.getHours() - 5);
      // console.log(date)
      // const timeDifference = date.getTimezoneOffset()
      // console.log(`Timezone offset: ${timeDifference}`)
      return this.$moment(date).format('DD/MM/YYYY');
    },
    onDeleteUser: function onDeleteUser(email) {
      var data = {
        "email": email
      };
      user_security_service.deleteUser(data).then(function (response) {
        if (response && response.data) {
          console.log(response);
          tasks.toast.success('Usuario eliminado');
        }
      });
    }
  }),
  computed: {
    rules: function rules() {
      var _this3 = this;
      return {
        period: [function (v) {
          return !!v || _this3.translate('reglas.period');
        }]
      };
    },
    label: function label() {
      return {
        use_case_name: this.translate('attributes.label.use_case_name'),
        duration: this.translate('attributes.label.duration'),
        detail_use_case: this.translate('attributes.label.detail_use_case'),
        add_sa_by_business_area: this.translate('attributes.label.add_sa_by_business_area'),
        users: this.translate('attributes.label.users')
      };
    },
    dateRangeText: function dateRangeText() {
      return this.dates.join(' ~ ');
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }
};